<div
  class="h-48 bg-primary-light mb-16 flex justify-center items-center w-[calc(100dvw-15px)] relative left-1/2 -translate-x-1/2">
  <h1 class="text-center text-[30px] font-bold max-w-4xl px-4">
    Te damos la bienvenida a la Plataforma de Gobernanza,
    {{ fullName | uppercaseFirst }}
  </h1>
</div>
<div class="my-16">
  <h2 class="text-[24px] font-bold">Mis adhesiones enviadas</h2>
  <p class="my-4 text-[16px] text-neutral-dark">
    Solicitudes realizadas como consumidor para la adhesión a protocolos de acceso de datos de otros cedentes.
  </p>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    <div *ngFor="let item of accessionsSent()">
      <app-home-card
        [title]="item.title"
        [count]="item.count"
        [textUrl]="item.textUrl"
        [url]="item.url"
        [description]="item.description"
        [state]="item.state" />
    </div>
  </div>
</div>
<div class="my-16">
  <h2 class="text-[24px] font-bold">Mis adhesiones recibidas</h2>
  <p class="my-4 text-[16px] text-neutral-dark">
    Peticiones recibidas desde otra unidad administrativa solicitando la adhesión a protocolos de acceso a datos
    ofrecidos como cedente.
  </p>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    <div *ngFor="let item of accessionsRequested()">
      <app-home-card
        [title]="item.title"
        [count]="item.count"
        [textUrl]="item.textUrl"
        [url]="item.url"
        [description]="item.description"
        [state]="item.state" />
    </div>
  </div>
</div>
